import { render } from "./Edit.vue?vue&type=template&id=83ad413c"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Campuses/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83ad413c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83ad413c', __exports__)) {
    api.reload('83ad413c', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=83ad413c", () => {
    api.rerender('83ad413c', render)
  })

}


export default __exports__